module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-container-single element-bodymatter element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-001"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-001-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-001-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("I")]), _vm._v("t comes")]), _vm._v(" at too high a price, having a baby, Liz decided. How do you hide the tears from fellow travellers as you remember his little face, now turned to his new, first day child-minder, happily smiling with no intentions of missing you at "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("all")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She was aching for him, this unplanned child. It hadn’t seemed so bad when she had taken him to meet Sadie Fremantle, to see if they bonded; Liz was only doing a bit of forward planning. Sadie was a single mum of thirty-nine with a twenty-year-old son, Christian, at Solent University, and she had taken the decision to become a registered childminder to bring in extra funding to supplement the money she earned auditing books from "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("home")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz still had three months of maternity leave left; she was simply making tentative enquiries. Those enquiries had morphed into an afternoon every week while baby Jacob learned to know the woman who would be his surrogate parent. Liz had also taken Gareth to meet Sadie a couple of times, to get his views on the woman who would have such a massive influence on their baby son’s early years, and Gareth had agreed with her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("choice")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And then reality hit, the tentative enquiries were well in the past, and she was to return to "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("work")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Banton and Hardwick, solicitors in Sheffield’s city centre, valued her. She wished they didn’t. She didn’t want to leave Jake with Sadie, she wanted to be there when he took his first step, got his first tooth, (which, at nine months and with no sign of a small white nub in his gums, was beginning to feel unlikely), spoke his first word; hence the tears as the tram took her ever further into the heart of the city on that cold January "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("morning")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("A couple of people spoke to her and asked if she was okay; she dabbed away the tears with a screwed-up piece of tissue and said she was "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("fine")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz exited the tram outside the cathedral and crossed Fargate to nip into Boots for more tissues. She thought she might need "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("them")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She headed down through Paradise Square and came to the imposing steps leading up to her place of "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("work")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz felt wobbly. She had last walked down those steps only two weeks away from giving birth, with Gareth waiting in the car, hazards flashing as he was parked illegally. She had been carrying armfuls of presents. The practice employed many people, and although the two partners to whom she was attached had bought her the pram, every other member of staff had bought her an individual "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("gift")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She took a deep breath and pushed thoughts of the last nine months to the back of her mind. She straightened her shoulders and climbed the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("steps")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("No tears, Liz, ")]), _vm._v("she warned herself. "), _c('i', [_vm._v("Be professional. Jake is in good hands, you don’t need to worry. You’re a forty-year-old woman, successful career, full of confidence, life sorted. Be "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("brave")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She didn’t know the receptionist, and the receptionist didn’t know her. "), _c('i', [_vm._v("Good start, Liz, ")]), _vm._v("she "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("thought")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She introduced herself and Karen welcomed her with a "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("smile")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘It’s good to meet you, Mrs Chambers. I’m Karen Lee. Mr Banton said you would be returning this week. This is your ID tag,’ and she handed over Liz’s lanyard, complete with the new picture she had emailed to HR the week "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("before")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thank you, Karen, it’s good to meet you, too. How long have you been "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("here")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Three months. I came as a temp, but I’ve been taken on "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("now")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You like "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("it")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Very much so. And it’s a lot more secure than working for an "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("agency")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sure,’ Liz said with a smile. ‘I worked for agencies at one point in my life…’ she shuddered. ‘Are Mr Banton and Mr Hardwick "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("in")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘They are. I’ll let them know you’ve arrived.’ She pressed the intercom button and then whispered to Liz, ‘I think they’re excited to have you "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("back")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz laughed and headed for the door to the executive offices. She waited until she heard the gentle click as Karen released the lock, then walked down the corridor to her room. It was an old building, and Tom Banton and Oliver Hardwick had kept it as separate offices, rather than knocking walls down to make it open-plan, filled with small dividing "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("partitions")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She walked into her office, the room that connected directly with both Tom and Oliver’s rooms, and wanted to cry yet "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("again")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Carefully positioned on her desk was a huge bouquet of yellow roses, and a pile of envelopes clearly containing cards. She put down her bag, took off her coat, and carried both to her small wardrobe; quickly ran a comb through her dark blonde hair, checked the miniscule amount of make-up she wore hadn’t disappeared altogether under the force of her tears, renewed her lipstick, and closed the wardrobe "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("door")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her first job every morning had always been to put on the percolator and to keep it running throughout the day. It had been replaced with a coffee machine of some magnificence. She hoped it came with an instruction "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("manual")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her desk phone buzzed once, and she moved to answer it. At least that hadn’t "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("changed")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Tom,’ she said, and "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("waited")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You’re "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("early")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Of "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("course")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I thought we agreed to your starting at ten instead of nine, to help with getting Jake to his "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("childminder")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘We "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("did")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So…?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I took that as “be here by "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("ten")]), _vm._v("”.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You like the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("flowers")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I love the flowers. Your "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("idea")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Tom Banton laughed. ‘No, Chloe’s idea. That’s what wives are for, isn’t "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("it")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I should have "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("guessed")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("should")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So, did you want "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("something")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Black, no sugar, "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("please")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Wow! Are you under "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("instructions")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Tom sighed audibly. ‘I am. Chloe has given me an ultimatum. If I don’t lose weight on my own, she’s going to register me for a gym. And I think Oliver probably needs a coffee as well. We’ve missed you, Liz. We’ve had to make our own "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("drinks")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She laughed. ‘Two coffees it is, "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("then")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She heard him return the laughter as he put down the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("phone")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She found the instruction manual for the coffee machine hidden behind it, so she worked out how to use it, then carried the drinks through to her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("employers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Waitress service,’ she said as she entered Tom’s room. He lifted his head, watching her. His ginger hair fell forward across his forehead, and he brushed it back, almost without realising he was doing it. ‘About damn time. Promise me you won’t have another "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("baby")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Depends who’s offering to be the daddy,’ she responded. ‘Tom Hardy, Rob Lowe, Benedict whatever his name is… I could be "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("persuaded")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He laughed. ‘Erm… before we get Oliver in here, there’s something you should know, so that you don’t inadvertently put your foot in it. Oliver and Julia have split up. I don’t know all the details, don’t know why, just that the divorce is in the offing. He’s not talked much about it… not to me, anyway. I don’t know whether he’ll tell you or not, but you needed to know. It doesn’t affect anything here, Julia’s always distanced herself from the "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("business")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz’s face showed her shock. She’d known Julia since school days, and had recognised her the first day she had started to work at Banton and Hardwick, in the photograph that always stood on Oliver’s desk. Oliver had confirmed that his wife was called Julia Froggatt in an earlier life, and he had passed on Liz’s best wishes to Julia that same evening. They had met up many times since, sharing a coffee and, in Julia’s case, marital "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("woes")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Liz nodded at Tom. ‘Okay, message understood.’ She thought back to their last phone conversation when she had, somewhat abruptly, told Julia to either put up with Oliver’s control issues, or walk away. She had obviously walked away, and Liz prayed that Oliver didn’t know of her part in the marital split. She made a mental note to ring Julia – they hadn’t been in touch for at least four or five "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("months")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Tom leaned forward to press his intercom. ‘Oliver, we have coffee made by a fair maid. You coming in here, or shall I send the wench into "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("you")]), _vm._v("?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Ten "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("seconds")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Oliver Hardwick was a handsome man, fairly small in stature at 5’6” and of slim build, but with an imposing presence; always quiet and ultra-professional within the office environment. He and Tom were almost the same age, with birthdays three days apart. At forty-three, Oliver looked slightly the younger of the two men. She remembered the feeling of amusement that all the significant men in her life, Gareth, Phil, Tom and Oliver, had been born within six months of each other, and all in the same year. A good year for the supply of handsome "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("men")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Oliver’s deep brown eyes searched out Liz as he walked through the connecting door and stepped inside Tom’s office. He picked up the mug of coffee, walked around the desk towards Liz and said, ‘You’re early.’ He leaned forward and kissed her cheek – she could smell the Creed that  surrounded him – and smiled. He truly was quite delicious. She shook her head, dismissing her "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("thoughts")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I know. As you’ve both mentioned it, is that going to be a problem? You see, I think it’s better than being "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("late")]), _vm._v(".’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The two men turned to each other, and spoke at the same time. ‘She’s "), _c('span', {
    staticClass: "last-word"
  }, [_vm._v("back")]), _vm._v(".’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-018ed2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-001.vue
// module id = 84
// module chunks = 0